/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionendday2Inputs */

const en_actionendday2 = /** @type {(inputs: Actionendday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Until`)
};

const de_actionendday2 = /** @type {(inputs: Actionendday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis`)
};

/**
* | output |
* | --- |
* | "Until" |
*
* @param {Actionendday2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionendday2 = /** @type {((inputs?: Actionendday2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionendday2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionendday2(inputs)
	return de_actionendday2(inputs)
});
export { actionendday2 as "actionEndDay" }